import React from "react";
import SideBar from "../sideBar";
import Header from "../header";
import "../../../index.scss";
function ClientLayout({ children }) {
  return (
    <div>
      <div className="">
        <SideBar />

        <Header />

        <div id="main">{children}</div>
      </div>
    </div>
    
  );
}

export default ClientLayout;
